<div [formGroup]="group">
    <div fxLayout="row">
        <mat-label class="slider-label" fxFlex="0 0 5%">{{data.minValue}}</mat-label>
        <mat-slider fxFlex="0 0 85%" matInput [formControlName]="field.name"
                    class="example-margin"
                    [disabled]="field.disabled == true? field.disabled : false"
                    [invert]="data.invert == true? data.invert : false"
                    [max]="data.maxValue? data.maxValue : 100 "
                    [min]="data.minValue? data.minValue : 0"
                    [step]="data.step? data.step : 1"
                    [thumbLabel]="data.thumbLabel == false ? data.thumbLabel : true"
                    [tickInterval]="data.tickInterval && data.showTicks ? data.tickInterval: 1"
                    [value]="field.value ? field.value : 0"
                    [vertical]="data?.vertical == true ? data.vertical : false">
        </mat-slider>
        <mat-label class="slider-label" fxFlex="0 0 5%">{{data.maxValue}}</mat-label>
    </div>
</div>






